<div *ngIf="isLoading" class="flex items-center justify-center h-screen">
  <p-progressSpinner></p-progressSpinner>
</div>
<div class="container px-4 py-10 mx-auto">
  <div *ngIf="!isLoading && object" class="bg-white rounded-md">
    <p-card>
      <div class="w-full p-7">
        <ng-template pTemplate="header">
          <h2 class="text-2xl font-bold">Subscription Details</h2>
        </ng-template>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-medium">Plan</label>

          <input
            p-inputText
            id="status"
            [(ngModel)]="object.plan!.name"
            type="text" />
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-medium">Status</label>

          <input
            p-inputText
            id="status"
            [(ngModel)]="object.status"
            type="text" />
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-medium">Next Due</label>
          {{ object.next_due | date : "medium" }}
        </div>

        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-medium">Amount</label>
          {{ object.amount | currency : "USD" }}
        </div>
        <div class="col-span-12 mb-4 md:col-span-6">
          <label for="status" class="block mb-1 font-medium">
            Actual Amount
          </label>

          {{ object.actual_amount | currency : "USD" }}
        </div>
        <ng-template pTemplate="footer">
          <button
            pButton
            label="Back to List"
            icon="pi pi-arrow-left"
            class="p-button-secondary"
            routerLink="/conduit/list"></button>
        </ng-template>
      </div>
    </p-card>
  </div>
</div>
